
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitomahabaleshwer() {



  const cardData =
  {
    keyword: 'Mumbai to Mahabaleshwar Cab Service',
    heading: 'AB Ghule Cabs: Mumbai to Mahabaleshwar Cab Service',
    headingDescription: 'Experience the scenic beauty and tranquility of Mahabaleshwar with AB Ghule Cabs’ Mumbai to Mahabaleshwar Cab Service. Whether you are looking for a peaceful getaway, a family trip, or a romantic retreat, our comfortable and well-maintained cabs ensure a smooth ride from Mumbai to Mahabaleshwar. Our experienced drivers are familiar with the best routes to make your journey hassle-free and enjoyable. Mahabaleshwar is approximately 260 km from Mumbai.',

    top: 'Top Places to Visit in Mahabaleshwar with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Mahabaleshwar Temple",
          description: "The Mahabaleshwar Temple is an ancient and revered temple dedicated to Lord Shiva. Located in the heart of Mahabaleshwar, this historical temple is not only a significant spiritual site but also a beautiful example of ancient architecture. It attracts pilgrims from across India and is known for its peaceful ambiance and historical importance. Visitors come here to seek spiritual peace and immerse themselves in the tranquil surroundings."
        },
        {
          title: "Venna Lake",
          description: "Venna Lake, one of Mahabaleshwar’s most popular tourist spots, is known for its scenic beauty and peaceful atmosphere. It is a perfect location for boating, where visitors can rent pedal boats and enjoy the serene waters amidst the lush green landscape. Horse riding along the lake's banks adds to the charm, making it an ideal destination for families and nature lovers looking for a relaxing day out."
        },
        {
          title: "Arthur's Seat",
          description: "Arthur’s Seat is often referred to as the 'Queen of all points' in Mahabaleshwar. It offers breathtaking panoramic views of the surrounding valleys, the Krishna River, and the Sahyadri mountain range. It is a perfect spot for photography enthusiasts and nature lovers who enjoy hiking and exploring new vistas. The view from here, especially during sunrise, is nothing short of mesmerizing."
        },
        {
          title: "Wilson Point",
          description: "Wilson Point is the highest point in Mahabaleshwar and is famous for its stunning sunrise views. The vast expanse of lush green valleys, distant hills, and panoramic landscapes make it a popular spot for sightseeing. Visitors can enjoy a peaceful morning here, witnessing the beauty of nature as the sun rises over the hills. The cool climate and tranquil surroundings add to the allure of this picturesque location."
        },
        {
          title: "Pratapgarh Fort",
          description: "Pratapgarh Fort is a historical site that holds great significance from the Maratha Empire. Built by Chhatrapati Shivaji Maharaj, the fort offers a glimpse into the past with its ancient ruins, watchtowers, and battle grounds. The fort is strategically located atop a hill, providing visitors with sweeping views of the surrounding valley and hills. Exploring the fort is a must for history buffs and those interested in the rich heritage of the Maratha Empire."
        },
        {
          title: "Lingmala Waterfall",
          description: "Lingmala Waterfall is a stunning natural attraction located a little off the main road. It is particularly beautiful during the monsoon season when the waterfall is in full flow, cascading down the rocks into a serene pool below. Surrounded by dense forests and hills, the waterfall is an ideal spot for nature lovers, offering a peaceful atmosphere for hiking and photography."
        },
        {
          title: "Mapro Garden",
          description: "Mapro Garden is a delightful stop for food lovers, especially those with a sweet tooth. Known for its strawberry-based products, the garden offers delicious strawberry shakes, jams, and chocolates made from fresh, locally grown strawberries. The garden itself is beautifully maintained, providing a peaceful space to relax while enjoying these delectable treats. It is a great place for families, foodies, and nature enthusiasts alike."
        },
        {
          title: "Elephant's Head Point",
          description: "Elephant’s Head Point is one of Mahabaleshwar’s most famous viewpoints, named after a unique rock formation that resembles the head of an elephant. The view from this point is stunning, with panoramic vistas of the valley, hills, and lush green landscapes. It is an ideal spot for nature lovers, photographers, and those seeking to connect with the natural beauty of Mahabaleshwar."
        },
        {
          title: "Mahabaleshwar Hill Station",
          description: "Mahabaleshwar Hill Station is known for its cool climate, lush greenery, and tranquil atmosphere. It provides a refreshing escape from the hustle and bustle of city life. Visitors can explore the quaint streets, enjoy the local food, and experience the unique charm of the hill station. The cool weather, scenic views, and peaceful environment make it a popular destination for both relaxation and adventure."
        },
        {
          title: "Wilson Point",
          description: "Wilson Point, as the highest point in Mahabaleshwar, is a prime location for witnessing the mesmerizing sunrise. From here, you get a panoramic view of the surrounding hills, valleys, and forests. It’s an ideal spot for a peaceful morning walk, photography, and enjoying nature. The cool breeze and the serenity of the area make it one of the most sought-after locations for tourists visiting Mahabaleshwar."
        }
      ],


   services: [
  {
    "name": "Mumbai to Mahabaleshwar Taxi Fare",
    description: "AB Ghule Cabs offers competitive and transparent pricing for the Mumbai to Mahabaleshwar taxi ride. Our fares are affordable with no hidden charges, ensuring a budget-friendly and comfortable journey to one of Maharashtra's most scenic hill stations. Whether you’re traveling solo, with family, or in a group, we provide clear and upfront pricing that caters to all needs."
  },
  {
    "name": "Mumbai to Mahabaleshwar Taxi",
    description: "Book a reliable taxi from Mumbai to Mahabaleshwar with AB Ghule Cabs. Our fleet of well-maintained vehicles and experienced drivers ensures a smooth, safe, and comfortable ride to one of the most popular hill stations in Maharashtra. Whether it’s a weekend getaway or a holiday trip, enjoy a stress-free and enjoyable journey with our professional services."
  },
  {
    "name": "Cab Fare from Mumbai to Mahabaleshwar",
    description: "AB Ghule Cabs offers transparent and affordable cab fares for the Mumbai to Mahabaleshwar journey. We provide competitive pricing for individuals, families, and groups, with no hidden costs. Our pricing is structured to suit various budgets, ensuring a cost-effective and comfortable journey. Contact us for customized quotes based on your travel needs."
  },
  {
    "name": "Cab Service from Mumbai to Mahabaleshwar",
    description: "Choose AB Ghule Cabs for a hassle-free and enjoyable cab service from Mumbai to Mahabaleshwar. We provide timely services with well-maintained vehicles and experienced drivers. Our mission is to ensure that your ride is comfortable and seamless, making your trip to this beautiful hill station memorable."
  },
  {
    "name": "Car Hire from Mumbai to Mahabaleshwar",
    description: "Rent a car from Mumbai to Mahabaleshwar with AB Ghule Cabs. We offer a variety of vehicles for hire, ensuring a comfortable and enjoyable ride to this popular hill station. Our flexible rental options allow you to plan your journey based on your convenience, whether you need a car for a day or a longer trip."
  },
  {
    "name": "Car from Mumbai to Mahabaleshwar",
    description: "Need a car from Mumbai to Mahabaleshwar? AB Ghule Cabs provides comfortable and spacious cars for your journey. Our experienced drivers ensure your safety and comfort, offering a smooth and relaxing trip to one of Maharashtra’s top tourist destinations."
  },
  {
    "name": "Mahabaleshwar to Mumbai Taxi",
    description: "AB Ghule Cabs also provides taxi services for the return journey from Mahabaleshwar to Mumbai. Whether you’re coming back after a vacation or business trip, we offer a smooth return journey with reliable drivers and well-maintained vehicles, ensuring you reach Mumbai comfortably and on time."
  },
  {
    "name": "Mumbai Airport to Mahabaleshwar Taxi",
    description: "Book a taxi from Mumbai Airport to Mahabaleshwar with AB Ghule Cabs. Our experienced drivers will ensure timely pickup and a comfortable ride to Mahabaleshwar. Enjoy a scenic journey with professional drivers who are committed to making your trip smooth and enjoyable from the airport to your hill station destination."
  },
  {
    "name": "Mumbai Mahabaleshwar Taxi Hire",
    description: "AB Ghule Cabs offers taxi hire services for your trip from Mumbai to Mahabaleshwar. Our fleet includes a wide range of vehicles to meet your travel needs, from compact cars to larger vehicles for groups. Hire your taxi today for a smooth, comfortable, and safe trip to Mahabaleshwar, one of Maharashtra’s most loved hill stations."
  },
  {
    "name": "Mumbai to Mahabaleshwar Cab Booking",
    description: "Booking a cab from Mumbai to Mahabaleshwar has never been easier with AB Ghule Cabs. Our easy-to-use online booking system ensures a hassle-free experience for your journey. Choose from a variety of vehicles and book your ride with just a few clicks for a comfortable trip to Mahabaleshwar."
  },
  {
    "name": "Mumbai to Mahabaleshwar Car Hire",
    description: "Rent a car for your journey from Mumbai to Mahabaleshwar with AB Ghule Cabs. We provide reliable car hire services with flexible rental packages to suit your needs. Our vehicles are well-maintained and driven by experienced professionals, ensuring a comfortable and safe ride."
  },
  {
    "name": "Mumbai to Mahabaleshwar Car Rental",
    description: "For reliable car rental services from Mumbai to Mahabaleshwar, choose AB Ghule Cabs. Our well-maintained cars and experienced drivers ensure a comfortable and safe trip. Whether you’re traveling solo or with a group, we provide car rental options that guarantee a smooth journey to Mahabaleshwar."
  },
  {
    "name": "Taxi for Mahabaleshwar from Mumbai",
    description: "AB Ghule Cabs provides dedicated taxi services for your trip from Mumbai to Mahabaleshwar. Our services are designed to make your journey comfortable, safe, and enjoyable. We offer a range of vehicles to suit your preferences and group size, ensuring a pleasant and memorable trip to this scenic hill station."
  },
  {
    "name": "Mumbai to Panchgani Cab",
    description: "Travel from Mumbai to Panchgani with AB Ghule Cabs. We offer affordable and reliable taxi services to Panchgani, ensuring you a pleasant journey through the beautiful landscapes. Whether you're heading to this popular hill station for leisure or business, we guarantee a comfortable and smooth ride."
  },
  {
    "name": "Mumbai to Pune Cab Booking",
    description: "Book your Mumbai to Pune cab with AB Ghule Cabs. We provide efficient and affordable taxi services to Pune, ensuring a smooth ride for both business and leisure travelers. Our professional drivers and well-maintained vehicles ensure a safe and comfortable journey to Pune."
  },
  {
    "name": "Mumbai Airport Taxi Booking Online",
    description: "AB Ghule Cabs offers easy online taxi booking for airport transfers in Mumbai. Whether you're arriving or departing, our professional drivers are ready to provide timely and comfortable airport taxi services. We ensure your airport journey starts and ends smoothly."
  },
  {
    "name": "Best Outstation Cab Service in Mumbai",
    description: "Looking for the best outstation cab service in Mumbai? AB Ghule Cabs provides reliable and affordable taxi services for outstation travel. Whether you're heading to Mahabaleshwar, Pune, or beyond, we have you covered with our fleet of well-maintained vehicles and professional drivers."
  },
  {
    "name": "Mumbai to Tapola Cab Booking",
    description: "Book a cab from Mumbai to Tapola with AB Ghule Cabs. Our drivers ensure a safe and comfortable journey to this scenic destination near Mahabaleshwar. Enjoy the picturesque landscapes and peaceful surroundings as you travel in comfort with AB Ghule Cabs."
  },
  {
    "name": "Mumbai to Panchgani Cab",
    description: "Choose AB Ghule Cabs for your Mumbai to Panchgani taxi service. We offer comfortable and affordable cabs for your journey to the beautiful hill station. Our professional drivers and modern vehicles ensure a smooth and enjoyable ride to Panchgani."
  },
  {
    "name": "Mumbai to Panchgani Cab Fare",
    description: "Get the best rates for a Mumbai to Panchgani cab with AB Ghule Cabs. We offer competitive pricing with no hidden charges for a comfortable ride. Our transparent fare system ensures you know the cost upfront, providing a stress-free travel experience."
  },
  {
    "name": "Mumbai to Panchgani Car Rental",
    description: "Rent a car from Mumbai to Panchgani with AB Ghule Cabs. Our rental services offer flexibility and comfort for your trip to this picturesque hill station. Choose from a variety of vehicles to ensure a comfortable and enjoyable ride."
  },
  {
    "name": "Mumbai to Panchgani Taxi",
    description: "Travel to Panchgani with AB Ghule Cabs. We offer a range of taxi options for your Mumbai to Panchgani journey, ensuring comfort and safety throughout the trip. Enjoy a seamless ride to this beautiful hill station with our professional drivers."
  },
  {
    "name": "Mumbai to Panchgani Taxi Fare",
    description: "AB Ghule Cabs provides affordable and transparent taxi fares for your Mumbai to Panchgani journey. Book your ride with us today for a hassle-free experience. We offer competitive rates with no hidden charges, ensuring a smooth and budget-friendly journey."
  },
  {
    "name": "Panchgani to Mumbai Taxi",
    description: "AB Ghule Cabs also provides taxi services from Panchgani to Mumbai. Our reliable drivers and well-maintained vehicles ensure a smooth and timely return journey. Whether it's a family vacation or business trip, we guarantee a comfortable ride back to Mumbai."
  },
  {
    "name": "Mumbai to Mahabaleshwar Cab Contact Number",
    description: "For prompt and efficient Mumbai to Mahabaleshwar cab services, contact AB Ghule Cabs at +91 8624029699. Our team is ready to ensure a smooth and enjoyable ride for all our customers. Whether you're booking for a group, family, or solo trip, we provide reliable and comfortable services to make your journey memorable."
  }
],
tableData: [
    ["Mumbai to Mahabaleshwar Taxi Fare", "Affordable pricing for a comfortable journey to Mahabaleshwar from Mumbai"],
    ["Cab Fare from Mumbai to Mahabaleshwar", "Competitive fares for a hassle-free ride to Mahabaleshwar"],
    ["Cab Service from Mumbai to Mahabaleshwar", "Reliable and professional taxi services for a smooth ride"],
    ["Car Hire from Mumbai to Mahabaleshwar", "Easy and convenient car hire for your Mahabaleshwar trip"],
    ["Car from Mumbai to Mahabaleshwar", "Comfortable and safe car options for a scenic trip to Mahabaleshwar"],
    ["Mahabaleshwar to Mumbai Taxi", "Reliable taxi service for your return journey from Mahabaleshwar to Mumbai"],
    ["Mumbai Airport to Mahabaleshwar Taxi", "Convenient airport taxi service from Mumbai Airport to Mahabaleshwar"],
    ["Mumbai Mahabaleshwar Taxi Hire", "Flexible taxi hire services for a smooth Mahabaleshwar journey"],
    ["Mumbai to Mahabaleshwar Cab Booking", "Hassle-free booking of your Mumbai to Mahabaleshwar cab"],
    ["Mumbai to Mahabaleshwar Car Hire", "Easy car hire services for a comfortable ride to Mahabaleshwar"],
    ["Mumbai to Mahabaleshwar Car Rental", "Affordable and reliable car rental options for your Mahabaleshwar trip"],
    ["Taxi for Mahabaleshwar from Mumbai", "Reliable taxi service for a scenic trip to Mahabaleshwar from Mumbai"],
    ["Mumbai to Panchgani Cab", "Comfortable and affordable cab service for your Mumbai to Panchgani trip"],
    ["Mumbai to Panchgani Cab Fare", "Transparent pricing for your Mumbai to Panchgani journey"],
    ["Mumbai to Panchgani Car Rental", "Convenient car rental options for a trip to Panchgani"],
    ["Mumbai to Panchgani Taxi", "Reliable taxi services for your Mumbai to Panchgani journey"],
    ["Mumbai to Panchgani Taxi Fare", "Affordable fares for a smooth and comfortable ride to Panchgani"],
    ["Panchgani to Mumbai Taxi", "Affordable and reliable taxi service for your return journey from Panchgani to Mumbai"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Professional Service",
      WhyChoosedescription: "At AB Ghule Cabs, we specialize in providing reliable and professional cab services for your Mumbai to Mahabaleshwar journey. Whether it's a short getaway or a special trip, our drivers are committed to delivering a comfortable, safe, and hassle-free ride."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Our services are available around the clock to meet your travel needs. Whether you're planning an early morning departure or a late-night trip, our team is ready to assist you with bookings anytime."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We believe in offering competitive pricing with no hidden charges. Whether it’s a one-way or round trip, our fare structure is transparent, ensuring that you get the best value for your money."
    },
    {
      WhyChooseheading: "Clean and Well-Maintained Fleet",
      WhyChoosedescription: "Our fleet of vehicles is well-maintained, regularly cleaned, and inspected to ensure a safe and comfortable ride. We offer a variety of vehicles, including sedans, SUVs, and luxury cars, to suit your preferences and travel needs."
    },
    {
      WhyChooseheading: "Experienced and Safe Drivers",
      WhyChoosedescription: "Safety is our top priority. All our drivers are experienced, highly trained, and background-checked. They are familiar with the best routes from Mumbai to Mahabaleshwar, ensuring timely and secure travel."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking your Mumbai to Mahabaleshwar cab is easy and quick. You can book through our website, mobile app, or by calling our customer service helpline. We ensure a smooth and seamless booking experience."
    },
    {
      WhyChooseheading: "Customer Satisfaction Guarantee",
      WhyChoosedescription: "Customer satisfaction is our primary goal. We are proud of the positive reviews and feedback from our clients who appreciate our reliable and top-quality service. Our team is always striving to improve and offer the best travel experience."
    }
  ]
  
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Mumbai to Mahabaleshwar cab with AB Ghule Cabs?',
      answer: 'You can easily book a cab through our website, mobile app, or by calling our customer service helpline. We offer a simple and quick booking process for your convenience.',
    },
    {
      id: 'FAQ2',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all of our drivers are experienced, highly trained, and background-checked to ensure your safety and comfort during the trip.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for Mumbai to Mahabaleshwar cab service?',
      answer: 'We offer a range of vehicles including sedans, SUVs, and luxury cars, catering to different travel needs. Choose the one that fits your preferences for comfort and space.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my Mumbai to Mahabaleshwar cab ride?',
      answer: 'You can pay for your ride using cash, credit/debit cards, or online payment through our website or mobile app, providing you with multiple payment options.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for detours or waiting time?',
      answer: 'Additional charges may apply for detours or waiting time, depending on the specifics of your trip. We ensure transparent pricing, and any extra charges will be communicated to you in advance.',
    },
    {
      id: 'FAQ6',
      question: 'How long does it take to travel from Mumbai to Mahabaleshwar?',
      answer: 'The journey typically takes around 5 to 6 hours, depending on traffic and road conditions. Our experienced drivers ensure a smooth and timely ride.',
    },
    {
      id: 'FAQ7',
      question: 'Can I modify or cancel my booking?',
      answer: 'Yes, you can easily modify or cancel your booking via our website or app. For assistance, you can also reach out to our customer service team.',
    },
    {
      id: 'FAQ8',
      question: 'Is AB Ghule Cabs available for a round trip to Mahabaleshwar?',
      answer: 'Yes, we offer round-trip services for your convenience. Our drivers are flexible and will adjust the trip based on your schedule.',
    },
    {
      id: 'FAQ9',
      question: 'What makes AB Ghule Cabs different from other Mumbai to Mahabaleshwar cab services?',
      answer: 'AB Ghule Cabs stands out with our commitment to customer satisfaction, affordable pricing, experienced drivers, and well-maintained fleet. We focus on providing a safe and comfortable experience for every traveler.',
    },
    {
      id: 'FAQ10',
      question: 'Can I book a cab for a group from Mumbai to Mahabaleshwar?',
      answer: 'Yes, we offer larger vehicles for group travel, ensuring ample space and comfort for your entire group. Please contact our customer service team for group bookings.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Raghav Desai",
      feedback: "I had a wonderful trip to Mahabaleshwar with AB Ghule Cabs. The car was clean and comfortable, and the driver was friendly and professional. We had a smooth journey, and the trip was exactly as planned. Highly recommend their services for anyone traveling from Mumbai to Mahabaleshwar!",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Shruti Joshi",
      feedback: "Our family used AB Ghule Cabs for a trip to Mahabaleshwar, and it was a great experience. The vehicle was spacious, and the driver was knowledgeable about the best routes. The whole process was easy and hassle-free. We’ll definitely use their services again!",
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Mumbai to Mahabaleshwar Taxi | Mahabaleshwar Cab Service</title>
  <meta name="description" content="Book Mumbai to Mahabaleshwar cab service for a hassle-free journey. Affordable taxi fare, reliable car rentals, and online cab booking available. Travel comfortably from Mumbai to Mahabaleshwar or Panchgani with professional drivers." />
  <meta name="keywords" content="Mumbai to Mahabaleshwar Taxi Fare, Mumbai to Mahabaleshwar Taxi, Cab Fare from Mumbai to Mahabaleshwar, Cab Service from Mumbai to Mahabaleshwar, Car Hire from Mumbai to Mahabaleshwar, Mahabaleshwar to Mumbai Taxi, Mumbai Airport to Mahabaleshwar Taxi, Mumbai to Mahabaleshwar Cab Booking, Mumbai to Mahabaleshwar Car Hire, Mumbai to Panchgani Cab, Mumbai to Panchgani Cab Fare, Mumbai to Panchgani Car Rental, Mumbai to Tapola Cab Booking, Best Outstation Cab Service in Mumbai, Mumbai to Panchgani Taxi Fare, Panchgani to Mumbai Taxi" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Mumbai to Mahabaleshwar Taxi | Mahabaleshwar Cab Service" />
  <meta property="og:description" content="Book Mumbai to Mahabaleshwar cab service for a hassle-free journey. Affordable taxi fare, reliable car rentals, and online cab booking available. Travel comfortably from Mumbai to Mahabaleshwar or Panchgani with professional drivers." />
  <meta property="og:image" content="https://abghulecabs.com/images/mumbai-to-mahabaleshwar-taxi.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/mumbai-to-mahabaleshwar-taxi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs",
        description: "Book Mumbai to Mahabaleshwar cab service for a hassle-free journey. Affordable taxi fare, reliable car rentals, and online cab booking available. Travel comfortably from Mumbai to Mahabaleshwar or Panchgani with professional drivers.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Mumbai, Maharashtra",
          "addressLocality": "Mumbai",
          "addressRegion": "Maharashtra",
          "postalCode": "400001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/mumbai-to-mahabaleshwar-taxi",
        "logo": "https://abghulecabs.com/images/mumbai-to-mahabaleshwar-taxi.jpg",
        "image": "https://abghulecabs.com/images/mumbai-to-mahabaleshwar-taxi.jpg",
        "priceRange": "₹3000 - ₹8000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/mumbai-to-mahabaleshwar-taxi",
          "priceCurrency": "INR",
          "price": "3000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1250"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anjali Sharma"
            },
            "datePublished": "2024-12-05",
            "reviewBody": "The cab service from Mumbai to Mahabaleshwar was exceptional. The vehicle was clean, and the driver was very courteous. Highly recommend!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rohit Desai"
            },
            "datePublished": "2024-11-20",
            "reviewBody": "Affordable rates and smooth travel experience. I used the service for a family trip to Mahabaleshwar, and it was perfect."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "19.0760",
            "longitude": "72.8777"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/mumbai-to-mahabaleshwar-taxi"
        },
        "keywords": "Mumbai to Mahabaleshwar Taxi Fare, Mumbai to Mahabaleshwar Taxi, Cab Fare from Mumbai to Mahabaleshwar, Cab Service from Mumbai to Mahabaleshwar, Car Hire from Mumbai to Mahabaleshwar, Mahabaleshwar to Mumbai Taxi, Mumbai Airport to Mahabaleshwar Taxi, Mumbai to Mahabaleshwar Cab Booking, Mumbai to Mahabaleshwar Car Hire, Mumbai to Panchgani Cab, Mumbai to Panchgani Cab Fare, Mumbai to Panchgani Car Rental, Mumbai to Tapola Cab Booking, Best Outstation Cab Service in Mumbai, Mumbai to Panchgani Taxi Fare, Panchgani to Mumbai Taxi"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/9.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaitomahabaleshwer;